import type { RefObject } from "react";
import React, { Fragment } from "react";

import * as css from "./atom.caption.style";
import { SliderModel } from "@courses-pm2/api";

type Props = {
  ref?: RefObject<HTMLSpanElement | null>;

  caption: SliderModel["caption"] | undefined;
};

const PUNCTUATION_REGEX = /[.,!?]\s*$/;

export function Caption(props: Props): React.JSX.Element | null {
  const displayCaption =
    !!props.caption?.authorOrArtist ||
    !!props.caption?.country ||
    !!props.caption?.duration ||
    !!props.caption?.year ||
    !!props.caption?.creditLine ||
    !!props.caption?.label;

  if (!displayCaption) {
    return null;
  }

  const caption = [
    props.caption?.label && (
      <span
        key="label"
        className={css.spanCls}
        dangerouslySetInnerHTML={{ __html: props.caption.label }}
        data-comma={!PUNCTUATION_REGEX.test(props.caption.label)}
      />
    ),
    props.caption?.authorOrArtist && (
      <span
        key="authorOrArtist"
        className={css.spanCls}
        dangerouslySetInnerHTML={{ __html: props.caption.authorOrArtist }}
        data-comma={!PUNCTUATION_REGEX.test(props.caption.authorOrArtist)}
      />
    ),
    props.caption?.country && (
      <span
        key="country"
        className={css.spanCls}
        dangerouslySetInnerHTML={{ __html: props.caption.country }}
        data-comma={!PUNCTUATION_REGEX.test(props.caption.country)}
      />
    ),
    props.caption?.duration && (
      <span
        key="duration"
        className={css.spanCls}
        dangerouslySetInnerHTML={{ __html: props.caption.duration }}
        data-comma={!PUNCTUATION_REGEX.test(props.caption.duration)}
      />
    ),
    props.caption?.year && (
      <span
        key="year"
        className={css.spanCls}
        dangerouslySetInnerHTML={{ __html: props.caption.year }}
        data-comma={!PUNCTUATION_REGEX.test(props.caption.year)}
      />
    ),
    props.caption?.creditLine && (
      <span
        key="creditLine"
        className={css.spanCls}
        dangerouslySetInnerHTML={{
          __html: "©&nbsp;" + props.caption.creditLine,
        }}
        data-comma={!PUNCTUATION_REGEX.test(props.caption.creditLine)}
      />
    ),
  ].filter((it): it is React.JSX.Element => !!it);

  return (
    <span ref={props.ref} className={css.captionCls}>
      <span className={css.contentCls}>
        {caption.map((it, index) => (
          <Fragment key={index}>
            {it}
            {index < caption.length - 1 &&
              (it.props["data-comma"] === true ? ", " : " ")}
          </Fragment>
        ))}
      </span>
    </span>
  );
}
